import React, { useEffect, useRef, useState } from 'react';


// Come MarcatoreQuotaTabella: l'evidenziazione della variazione e' passata da un setTimeout per
// cella (mai ripulito) a un'animazione CSS. Lo stato "open", che decide se mostrare anche la
// quota di punta, resta locale perche' e' una scelta dell'utente sulla singola cella.
const MarcatoreQuotaTabellaBF = (props) => {
    const { quota } = props;
    const { quota_2 } = props;
    const [variazione, setVariazione] = useState(null);
    const [contatoreVariazioni, setContatoreVariazioni] = useState(0);
    const prevQuota = useRef(undefined);
    // variabile per gestire l'apertura del componente se visualizzare anche la quota 2 o meno
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const precedente = prevQuota.current;
        prevQuota.current = quota;
        if (precedente !== undefined && precedente !== quota && quota > 1) {
            setVariazione(parseFloat(precedente) > parseFloat(quota) ? 'giu' : 'su');
            setContatoreVariazioni((valore) => valore + 1);
        }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [quota]);

    return (
        <>
            <div
                key={contatoreVariazioni}
                className={"position-relative" + (variazione ? " quota-variata" : "")}
                title={props.title}
                onClick={()=>setOpen(!open)}
            >
                { open ?
                        <div className='d-flex flex-row'>
                            <div className={"position-relative "} style={{float: "left", width: "33px", backgroundColor: "#a6d8ff", textWrap: 'nowrap', overflow: 'hidden'}}>
                            <i className={"position-absolute "}></i>
                            {quota_2 > 1 ? parseFloat(quota_2).toFixed(2) : '-'}
                            </div>
                            <div className={"position-relative "} style={{float: "right", width: "33px", background: "#f694aa", textWrap: 'nowrap', overflow: 'hidden'}}>
                                <i className={"position-absolute "}></i>
                                {quota > 1 ? parseFloat(quota).toFixed(2) : '-'}
                            </div>
                        </div>
                        :
                        <div>
                                <i
                                    className={"position-absolute " + (variazione === 'giu'
                                        ? 'bi bi-arrow-down text-danger'
                                        : (variazione === 'su' ? 'bi bi-arrow-up text-success' : ''))}
                                    style={{left: "5px", top: "-1px"}}
                                ></i>
                                {quota > 1 ? parseFloat(quota).toFixed(2) : '-'}
                        </div>
                }
            </div>
        </>
    );
}

export default React.memo(MarcatoreQuotaTabellaBF);
